import React from "react";

function CommentIcon() {
  return (
    <span className="anticon ant-comment">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="17"
        viewBox="0 0 20 17"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#545B66"
          d="M7.49 15.971a.374.374 0 01-.233-.346V13h-.375c-3.308 0-6-2.692-6-6s2.692-6 6-6h6c3.309 0 6 2.692 6 6s-2.691 6-6 6h-2.094l-2.89 2.89a.375.375 0 01-.409.081z"
        ></path>
      </svg>
    </span>
  );
}

export default CommentIcon;
